export { default } from './Panels';
